import React from 'react';

type PaperclipIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function PaperclipIcon({ onClick, className = '' }: PaperclipIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M16.5 9.5L9 17C7.5 18.5 5 18.5 3.5 17C2 15.5 2 13 3.5 11.5L12 3C13 2 14.5 2 15.5 3C16.5 4 16.5 5.5 15.5 6.5L6 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PaperclipIcon;
